export default __webpack_public_path__ + "static/media/pan.6e38a149.jpg";